import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useTranslation } from 'react-i18next';
import { REASON_FOR_OPEN_ARRAY } from './consts';
import { AccountOpeningReasonList } from './components/AccountOpeningReasonList';
import { useAccountOpeningReasonLogic } from './hooks/useAccountOpeningReasonLogic';
import { OtherAccountOpeningReasonModal } from './components/OtherAccountOpeningReasonModal';

export const AccountOpeningReason = () => {
  const { t } = useTranslation();
  const { isOtherModalOpen, onClickItem, closeModal, mutateAsync, isPending } =
    useAccountOpeningReasonLogic();

  return (
    <StepPageWrapper heading={t('pages.accountOpeningReason.title')}>
      <AccountOpeningReasonList reasonList={REASON_FOR_OPEN_ARRAY} onClickItem={onClickItem} />
      {isOtherModalOpen && (
        <OtherAccountOpeningReasonModal
          onSubmit={mutateAsync}
          onCancel={closeModal}
          isLoading={isPending}
        />
      )}
    </StepPageWrapper>
  );
};
